module.exports = __webpack_public_path__ + "static/media/54_1123.8fb0c7e9.webp";